import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Eye, ScanEye, Activity, Droplets, Waves, Syringe, Stethoscope, ShieldCheck, ArrowRight,
} from "lucide-react";
import SectionHeader from "../components/site/SectionHeader";
import api from "../lib/api";
import { usePageMeta, usePageJsonLd } from "../hooks/usePageMeta";
import { breadcrumb, graph } from "../lib/schema";

const iconMap = {
  eye: Eye, "scan-eye": ScanEye, activity: Activity, droplets: Droplets,
  waves: Waves, syringe: Syringe, stethoscope: Stethoscope, "shield-check": ShieldCheck,
};

const Expertise = () => {
  usePageMeta({
    title: "Areas of Expertise | Dr. Shantanu Kumar Gupta, Varanasi",
    path: "/expertise",
    description: "Premium cataract surgery, cornea, medical retina, diabetic retinopathy, AMD, retina injections and second opinions in Varanasi.",
  });
  usePageJsonLd(graph([breadcrumb([{ name: "Home", path: "/" }, { name: "Expertise", path: "/expertise" }])]));
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/expertise").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="expertise-page">
      <section className="pt-20 pb-8 container-page">
        <div className="overline mb-4">Areas of Expertise</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-balance max-w-3xl">
          Comprehensive eye services, delivered with meticulous care.
        </h1>
        <p className="mt-6 max-w-2xl prose-elegant">
          Explore every service offered at Shantanu Netralaya — from premium cataract surgery
          and medical retina to comprehensive eye examinations and independent second opinions.
        </p>
      </section>
      <section className="py-16 container-page grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="expertise-list">
        {items.map((e) => {
          const Icon = iconMap[e.icon] || Eye;
          return (
            <Link
              key={e.slug}
              to={`/expertise/${e.slug}`}
              className="card-elegant p-8 group block"
              data-testid={`service-card-${e.slug}`}
            >
              <Icon size={34} strokeWidth={1.25} className="text-[hsl(var(--primary))]" />
              <h3 className="font-serif text-2xl mt-6 leading-snug">{e.title}</h3>
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{e.tagline}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[hsl(var(--primary))]">
                Explore <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          );
        })}
      </section>
    </div>
  );
};

export default Expertise;
